import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "modal", "input", "name", "errors", "send" ]

  showModal() {
    this.modalTarget.classList.add('is-active')
  }

  closeModal() {
    this.modalTarget.classList.remove('is-active')
  }

  checkValidation() {
    const errors = this.checkTag(this.inputTarget.value, [])
    this.errorsTarget.textContent = errors.join('\n')
    if(errors.length > 0) {
      this.sendTarget.disabled = true
    }else{
      this.sendTarget.disabled = false
    }
  }

  checkTag(value, errors = []) {
    return [
      ...this.tagMustBeFull(value, errors),
      ...this.tagMustBeUniq(value, errors),
      ...this.tagMustBeValidFormat(value, errors)
    ]
  }

  tagMustBeFull(value, errors = []) {
    let errs = []
    Object.assign(errs, errors)
    if(value === '') {
      errs.push('ハッシュタグを入力してください。')
    }
    return errs
  }

  tagMustBeUniq(value, errors = []) {
    let errs = []
    Object.assign(errs, errors)

    // 入力値の # を除去して比較
    const normalized = value.replace(/#/g, "").trim()
    const names = this.nameTargets.map((item) => item.textContent)
    if(names.includes(normalized)) {
      errs.push('同じハッシュタグが含まれています。')
    }
    return errs
  }

  tagMustBeValidFormat(value, errors = []) {
    let errs = []
    Object.assign(errs, errors)
    if (!value) return errs;

    if (value.includes('　')) errs.push('全角スペースが含まれています。');
    if (value.includes(' ')) errs.push('半角スペースが含まれています。');
    if (/＃/.test(value)) { errs.push('全角＃が含まれています。'); }
    if (/\$/.test(value)) { errs.push('$が含まれています。'); }
    if (/%/.test(value)) { errs.push('%が含まれています。'); }

    return errs
  }
}
